module.exports = __webpack_public_path__ + "static/media/90244_01big.8f5b15f4.jpg";